function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.31 19.314a5 5 0 01-4.995 4.995H7.362a5 5 0 01-4.995-4.995V7.361a5 5 0 014.995-4.995h11.953A5 5 0 0124.31 7.36zM19.315-.001H7.362C3.302-.001 0 3.3 0 7.36v11.953c0 4.06 3.302 7.362 7.362 7.362h11.953c4.06 0 7.362-3.303 7.362-7.362V7.361c0-4.06-3.303-7.362-7.362-7.362",
  fill: "#808285"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.33 17.844a4.512 4.512 0 01-4.507-4.506c0-2.485 2.021-4.508 4.507-4.508s4.507 2.023 4.507 4.508a4.512 4.512 0 01-4.507 4.506m0-11.38a6.882 6.882 0 00-6.874 6.874 6.882 6.882 0 006.874 6.874 6.882 6.882 0 006.874-6.874 6.882 6.882 0 00-6.874-6.874M20.5 4.458a1.742 1.742 0 00-1.736 1.736c0 .456.187.903.51 1.227.321.322.77.508 1.226.508.458 0 .904-.186 1.227-.508a1.75 1.75 0 00.509-1.227c0-.458-.185-.906-.509-1.228a1.742 1.742 0 00-1.227-.508",
  fill: "#808285"
});

var SvgLogoInstagram = function SvgLogoInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 26.677 26.677",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-instagram.d4469b3d.svg";
export { ForwardRef as ReactComponent };